const API_PA = "https://tomecarvalho.eu.pythonanywhere.com/ws";

const API_URL = process.env.REACT_APP_API_URL || API_PA;

export default API_URL;
